import { render, staticRenderFns } from "./IndicationsLecformsTable.vue?vue&type=template&id=99f3cdea&scoped=true"
import script from "./IndicationsLecformsTable.vue?vue&type=script&lang=js"
export * from "./IndicationsLecformsTable.vue?vue&type=script&lang=js"
import style0 from "./IndicationsLecformsTable.vue?vue&type=style&index=0&id=99f3cdea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f3cdea",
  null
  
)

export default component.exports